import { render, staticRenderFns } from "./studymodulefile.vue?vue&type=template&id=018c5c42&"
import script from "./studymodulefile.vue?vue&type=script&lang=js&"
export * from "./studymodulefile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports